export const STATUS = {
  SUCCESS: 'SUCCESS',
  WAITING: 'WAITING',
};
export const COMPONENT_TYPE = {
  FORM: 'form',
  FORM_SECTION: 'form_section',
  SEQUENTIAL_FORM: 'sequential_form',
  LOOP_THROUGH_LIST: 'loop_through_list',
};
